import { render, staticRenderFns } from "./addDietPlan.vue?vue&type=template&id=5d99f898"
import script from "./addDietPlan.vue?vue&type=script&lang=js"
export * from "./addDietPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports